<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 17:53:28
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 14:29:02
 * @FilePath: \zhucai_user\src\pages\member\child\Exercise.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">我的收藏</div>
    <div class="my-content">
      <div class="my-search-box">
        <div class="my-search">
          <i class="el-icon-search" @click="getList"></i>
          <input
            type="text"
            @keyup.enter="getList"
            v-model="getListData.Title"
            placeholder="输入关键词搜索"
          />
        </div>
        <el-button @click="getList" class="search-btn">搜索</el-button>
      </div>
      <el-table v-loading="isLoading" :data="tableData" class="mt20">
        <el-table-column prop="date" label="练习名称">
          <template slot-scope="scope">
            <div class="Exercise-box">
              <div class="img">
                <img src="@/assets/img/member/38.png" alt="" />
              </div>
              <div class="flex1">
                <p class="ExerciseName">{{ scope.row.ExerciseName }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="ClassifyName"
          label="分类"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="TotalNum"
          label="题量"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ValidityTimeTxt"
          label="有效期"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="address" label="操作" width="240" align="center">
          <template slot-scope="scope">
            <el-button class="table-btn" @click="toExercise(scope.row)">
              查看
            </el-button>
            <el-button class="table-btn" @click="hanldDel(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :total="total"
        :pageSize="getListData.PageSize"
        v-model="getListData.PageIndex"
      ></my-pagination>
    </div>
  </div>
</template>

<script>
import { GetMyFavExerList, FavDel } from "@/api/member";
import myPagination from "@/components/myPagination.vue";
export default {
  components: { myPagination },
  name: "GetMyFavExerList",
  data() {
    return {
      isLoading: true,
      total: 0,
      tableData: [],
      getListData: {
        Title: "",
        PageIndex: 1,
        PageSize: 10,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    toExercise(data) {
      this.$router.push({
        path: "/qbankDetail",
        query: {
          ExerciseID: data.ExerciseID,
        },
      });
    },
    hanldDel(data) {
      this.$confirm("此操作将删除收藏练习, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: "warning",
        customClass: "my-messagebox",
      }).then(() => {
        FavDel({
          FavID: data.FavID,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.getList();
          }
        });
      });
    },
    getList() {
      this.isLoading = true;
      const data = this.getListData;
      GetMyFavExerList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.Exercise-box {
  display: flex;
  gap: 20px;
  align-items: center;
  .img {
    width: 28px;
    height: 28px;
  }
  .ExerciseName {
    font-size: 20px;
    color: #333333;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>
